
export const text = `
[ID: A photo of inside a plane. The photographer is at the seat furthest away from the window. Next to them are two women: the one in the middle seat has fallen asleep, and her head is laying on the taller one’s lap, using her black coat as a pillow. The other woman remains expressionless as she is reclined on her seat. She is staring out the window.]



`